import React from "react";
import { useEffect,useContext,useState } from "react";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { methods } from '../../Validation';
import { AppRefreshContext } from '../../AppRefresh';
import axios from 'axios';



    

const Body = () => {
  const { refreshApp } = useContext(AppRefreshContext);
   const { t, i18n } = useTranslation();
    const { setLogin } = useContext(GlobalContext);
    const loader = document.getElementById("loder-tive");
    const [showPassword_old, setShowPassword] = useState(false);
    const [showPassword_new, setShowPasswordNew] = useState(false);
    const [showPassword_confirm, setShowPasswordConfirm] = useState(false);
      const EyeOpen = (
   <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 4.45962C9.91153 4.16968 10.9104 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C3.75612 8.07914 4.32973 7.43025 5 6.82137" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#1C274C" stroke-width="1.5"/>
</svg>
  );

  const EyeClosed = (
   <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.83 9.17999C14.2706 8.61995 13.5576 8.23846 12.7813 8.08386C12.0049 7.92926 11.2002 8.00851 10.4689 8.31152C9.73758 8.61453 9.11264 9.12769 8.67316 9.78607C8.23367 10.4444 7.99938 11.2184 8 12.01C7.99916 13.0663 8.41619 14.08 9.16004 14.83" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 16.01C13.0609 16.01 14.0783 15.5886 14.8284 14.8384C15.5786 14.0883 16 13.0709 16 12.01" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.61 6.39004L6.38 17.62C4.6208 15.9966 3.14099 14.0944 2 11.99C6.71 3.76002 12.44 1.89004 17.61 6.39004Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.9994 3L17.6094 6.39" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.38 17.62L3 21" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5695 8.42999C20.4801 9.55186 21.2931 10.7496 21.9995 12.01C17.9995 19.01 13.2695 21.4 8.76953 19.23" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );

       const [showThanks,setSetshowThanks] = useState(true);
       const [formData, setFormData] = useState({
           oldPassword: '',
           newPassword: '',
           confirmPassword: '',
   
         });
         const [back_end_error,setBack_end_error] = useState(null);
           let [formdata_valid_error,setFormDatavalid] = useState({//validName
                 oldPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Old_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:t('Old_password_does_not_match')}],required:true,error:false,errormsg:null
                 },
                 newPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('New_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Minimun 8 characters required"}],required:true,error:false,errormsg:null
                 },
                 confirmPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Confirm_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Minimun 8 characters required"},{keyname:'checkConfirmpassword',methods:'checkConfirmpassword',parmeters:[{password:formData.newPassword}],errormag:t('Password_does_not_match')}],con_index:2,required:true,error:false,errormsg:null},
         
               });
        
  
       const { siteName } = useContext(GlobalContext);
     
       let baseUrl = siteName.baseUrl;
       let webEndpoints = siteName.webEndpoints;
    

       const handleChange = (e) => {
            const { name, value } = e.target;
           
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
                    let add_confirmation = false;
                if ("con_index" in formdata_valid_error[name]) {
                    add_confirmation = true;
                }
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if(add_confirmation){
                           if(i == formdata_valid_error[name].con_index){
                         
                            formdata_valid_error[name].validtion[i].parmeters[0].password = formData.newPassword;
                           } 
                        }
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
           
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                   loader.classList.remove('d-none');
                  let value;
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                             let add_confirmation = false;
                                if ("con_index" in formdata_valid_error[name]) {
                                    add_confirmation = true;
                                }
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                               if(add_confirmation){
                           if(i == formdata_valid_error[name].con_index){
                         
                            formdata_valid_error[name].validtion[i].parmeters[0].password = formData.newPassword;
                           } 
                        }
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false;
                              loader.classList.add('d-none'); 
                             break;
                          }
                       }
          
                       if(validation){
                                     
                          console.log('Form submitted:', 'success');
                          console.log('Form submitted:', formData);
                          handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          console.log('Form submitted:', 'faild');
                          console.log('Form submitted:', formData);

                          
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                 console.log(formData);


            const response = await axios.post(baseUrl+webEndpoints+'change/password', formdata_submit,{
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });
          let data = response;
          
          /*call back data*/
        setFormData({
           oldPassword: '',
           newPassword: '',
           confirmPassword: '',
   
         });
      if(data.status){
        setSetshowThanks(false);
         loader.classList.add('d-none'); 
        setTimeout(() => {
         
            const logout_action = (setLogin) => {
             
          localStorage.removeItem('token');
          localStorage.removeItem('name');
          localStorage.removeItem('loginbefore');
          localStorage.removeItem('role');
           loader.classList.add('d-none');
         refreshApp();
         //  window.location.replace(window.location.href);
          window.location.href = '/';
        };
        logout_action()
        }, 1000);
        
      }
      //window.location.reload();
         
        } catch (error) {
          //setErrormsg(error.response.data.message);
           loader.classList.add('d-none'); 
          console.log(error.response.data);
          setBack_end_error(error.response.data.message);
          /*error call back*/
        }
      
    };

     
   ;

return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('reset_password')}</h3>
            </div>
            <div class="form-items-wrapper">
                {back_end_error !=null? <div class="error">{back_end_error}</div> : ''}
                <div class="form-intem form-item-full">
                    <label for="oldPassword">{t('temporary_password')}{formdata_valid_error.oldPassword.required? <span>*</span> : ''}</label>
                    <input type={showPassword_old ? "text" : "password"} onChange={handleChange} placeholder={t('temporary_password')}  name="oldPassword" id="oldPassword" />
                       {formdata_valid_error.oldPassword.error? <div className="error">{formdata_valid_error.oldPassword.errormsg}</div> : ''}
                              <span
        onClick={() => setShowPassword(!showPassword_old)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50px",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showPassword_old ? EyeClosed : EyeOpen}</span>
                </div>
                <div class="form-intem form-item-full">
                    <label for="newPassword">{t('new_password')}{formdata_valid_error.newPassword.required? <span>*</span> : ''}</label>
                    <input type={showPassword_new ? "text" : "password"} onChange={handleChange}  name="newPassword" id="newPassword" placeholder={t('new_password')} />
                     {formdata_valid_error.newPassword.error? <div className="error">{formdata_valid_error.newPassword.errormsg}</div> : ''}
                                  <span
        onClick={() => setShowPasswordNew(!showPassword_new)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50px",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showPassword_new ? EyeClosed : EyeOpen}</span>
                </div>
          
                <div class="form-intem form-item-full">
                    <label for="confirmPassword">{t("confirm_password")}{formdata_valid_error.confirmPassword.required? <span>*</span> : ''}</label>
                    <input  type={showPassword_confirm ? "text" : "password"} onChange={handleChange}  name="confirmPassword" id="confirmPassword" placeholder={t("confirm_password")} />
                    {formdata_valid_error.confirmPassword.error? <div className="error">{formdata_valid_error.confirmPassword.errormsg}</div> : ''}
                                            <span
        onClick={() => setShowPasswordConfirm(!showPassword_confirm)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50px",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showPassword_confirm ? EyeClosed : EyeOpen}</span>
                </div>
                 
           
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                             {t('Password_changed_successfully')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;